import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithReauth } from '@/services';
import { PaginatedRequest } from '@/types';
import { API_BUSINESS_URL } from '@/utils';
import { LogisticOperatorApi } from '../../LogisticOperator/models';

const headquarterLogisticOperatorsService = createApi({
  reducerPath: 'headquarterLogisticOperatorsService',
  baseQuery: createBaseQueryWithReauth(`${API_BUSINESS_URL}/logistic-operator`),
  tagTypes: ['HeadquarterLogisticOperators'],
  endpoints: (builder) => ({
    getHeadquarterLogisticOperators: builder.query<
      LogisticOperatorApi[],
      { paginated: PaginatedRequest }
    >({
      query: ({ paginated }) => ({
        url: '/headquarters',
        params: {
          limit: paginated.pageSize,
          offset: (paginated.page - 1) * paginated.pageSize,
        },
      }),
      providesTags: ['HeadquarterLogisticOperators'],
    }),
    getLogisticOperatorChildren: builder.query<
      LogisticOperatorApi[],
      { parentId: string; paginated: PaginatedRequest }
    >({
      query: ({ parentId, paginated }) => ({
        url: `/${parentId}/children`,
        params: {
          limit: paginated.pageSize,
          offset: (paginated.page - 1) * paginated.pageSize,
        },
      }),
      providesTags: ['HeadquarterLogisticOperators'],
    }),
  }),
});

export default headquarterLogisticOperatorsService;
export const {
  useGetHeadquarterLogisticOperatorsQuery,
  useGetLogisticOperatorChildrenQuery,
} = headquarterLogisticOperatorsService;

